import React, { useState, useEffect } from "react";
import { useSnackBar } from "../../../../../hooks/useSnackBar";
import "./Shipments.css";

// components imports
import TicketCreateModal from "./Components/TicketCreateModal/TicketCreateModal";
import AssignPickup from "./Components/AssignPickup/AssignPickup";
import InvoiceModal from "../../../../../Components/InvoiceModal/InvoiceModal";
import Confirm from "../../../../../Components/Popups/Confirm";
// apis imports
import {
  fetchShipments,
  cancelShipment,
  fetchShipmentDataById,
} from "../../../../../services/ShipperServices/Shipments/shipments.services";
import { updateUser } from "../../../../../store/userSlice";
import { initialShippmentsTab } from "../../../../../data/permissionsArray";
import { limitsTabsByPermission } from "../../../../../helpers/storeAccess";
import CircularLoader from "../../../../../Components/CircularLoader/CircularLoader";
import ShipmentsTable from "../../../../../Components/BoltTable/BoltTable";
import StatusIcons from "../../../../../Components/StatusIcons/StatusIcons";
import ActionDropDown from "./Components/TicketCreateModal/ActionDropDown/ActionDropDown";

// library imports
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { FaEdit } from "react-icons/fa";
import { MdComment } from "react-icons/md";
import TabsComponent from "../../../../../Components/Common/TabsComponent";
import { convertTime } from "../../../../../helpers/helpers";
import { formatMoney } from "../../../../../helpers/money";
import HyperLink from "../../../../../Components/HyperLink/HyperLink";
import ShipmentPackagesPreview from "../../../../../Components/Shared/Shipment/ShipmentPackages/ShipmentPackagesPreview";

// Two values in one cell: the main one, with a lighter line underneath.
const StackedCell = ({ primary, secondary, className = "" }) => (
  <div className={`flex flex-col ${className}`}>
    <span>{primary}</span>
    <span className="text-ui-text-subtle font-normal">{secondary}</span>
  </div>
);

const Shipments = () => {
  const [confirmCancel, setConfirmCancel] = useState(false);
  const [labelDownloading, setLabelDownloading] = useState("");
  const [shipments, setShipments] = useState([]);
  const [invoiceModal, setInvoiceModal] = useState(false);
  const [assignPickupModal, setAssignPickupModal] = useState(false);

  const [cancelingShipment, setCancelingShipment] = useState();
  const [tab, setTab] = useState("all");
  const [tabPermissions, setTabPermissions] = useState(initialShippmentsTab);
  const setSnack = useSnackBar();
  const user = useSelector((state) => state.user);
  const Navigate = useNavigate();
  const dispatch = useDispatch();
  useEffect(() => {
    if (limitsTabsByPermission(user)) {
      let validPermissions = initialShippmentsTab.filter((t) =>
        user?.mergedPermissions?.includes(t.name),
      );
      if (validPermissions?.length > 0) {
        setTab(validPermissions[0]?.value);
      } else {
        setTab("nothing");
      }
      setTabPermissions(validPermissions);
    } else {
      setTab("all");
    }
  }, []);
  const [ticketCreateModal, setTicketCreateModal] = useState(false);

  const handleReShip = async (row) => {
    try {
      let data = await fetchShipmentDataById(row?.id);
      if (Object.keys(data?.data?.result).length !== 0) {
        localStorage.setItem("Reship", JSON.stringify(data?.data?.result));
        Navigate("/");
      } else {
        // Handle the case where data is empty
        setSnack((snack) => ({
          ...snack,
          open: true,
          text: "No shipment data available",
          severity: "warning",
        }));
      }
    } catch (error) {
      // Handle any errors that occur during the API call
      console.error("Error fetching shipment data:", error);
      setSnack((snack) => ({
        ...snack,
        open: true,
        text: "Something went wrong",
        severity: "error",
      }));
    }
  };

  const handleTicketOpen = (row) => {
    if (row?.tickets?.length > 0 && row?.tickets[0]?.created_by == user.id)
      Navigate({
        pathname: "/Tickets",
        search: `?ticket_no=${row?.tickets[0]?.ticket_no}`,
      });
    else setTicketCreateModal(row);
  };

  const printLabel = async (row) => {
    setLabelDownloading("label" + row?.id);
    try {
      fetch(row?.single_shipping_labels.file, {
        method: "GET",
        headers: {
          "Content-Type": "application/pdf",
        },
      })
        .then((url) => url.blob())
        .then((blob) => {
          const url = window.URL.createObjectURL(new Blob([blob]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute(
            "download",
            `${row.tattension + " " + row.shipment_tracking_id} Label.pdf`,
          );
          document.body.appendChild(link);
          link.click();
          link.parentNode.removeChild(link);
          setLabelDownloading("");
        });
    } catch (error) {
      setLabelDownloading("");
    }
  };
  const printDeclaration = async (row) => {
    setLabelDownloading("Declaration" + row?.id);
    // console.log(row.single_shipping_labels.file);
    try {
      fetch(row?.single_shipping_invoice.file, {
        method: "GET",
        headers: {
          "Content-Type": "application/pdf",
        },
      })
        .then((url) => url.blob())
        .then((blob) => {
          const url = window.URL.createObjectURL(new Blob([blob]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute(
            "download",
            `${row.tattension + " " + row.shipment_tracking_id} Declaration.pdf`,
          );
          document.body.appendChild(link);
          link.click();
          link.parentNode.removeChild(link);
          setLabelDownloading("");
        });
    } catch (error) {
      setLabelDownloading("");
    }
  };
  const handleCancelShipment = async (id) => {
    setCancelingShipment(true);
    try {
      const response = await cancelShipment(id);
      if (!response.error) {
        setShipments((prevShipments) => {
          return {
            ...prevShipments,
            data: prevShipments?.data?.map((shipment) => {
              if (shipment?.id === id) {
                return {
                  ...shipment,
                  shipment_status: response?.data?.result?.shipment_status,
                };
              } else {
                return shipment;
              }
            }),
          };
        });
        setCancelingShipment(false);
        setConfirmCancel(false);
        setSnack((snack) => {
          return {
            ...snack,
            open: true,
            text: response?.data?.message,
            severity: "success",
          };
        });
      } else {
        setCancelingShipment(false);
        setSnack((snack) => {
          return {
            ...snack,
            open: true,
            text:
              response?.error?.response?.data?.message ??
              "Something went wrong",
            severity: "error",
          };
        });
      }
    } catch (error) {
      setCancelingShipment(false);
      setSnack({
        open: true,
        text: error?.message || "Something went wrong!",
        severity: "error",
      });
    }
  };

  function isCancelled(status) {
    const lowerCaseStatus = status ? status.toLowerCase() : null;
    return lowerCaseStatus === "cancelled";
  }

  const columns = [
    {
      id: 0,
      label: "#",
      render: (row) => <>{row?.id ?? "-"}</>,
      width: "200px",
      disabled: (row) => isCancelled(row?.shipment_status),
    },
    {
      id: 1,
      label: "Carrier",
      render: (row) => (
        <>
          <img
            src={row?.shipping_company?.shipping_company?.logo_url}
            loading="lazy"
          />
        </>
      ),
      width: "200px",
      fixed: "left",
      disabled: (row) => isCancelled(row?.shipment_status),
    },
    {
      id: 2,
      label: "Service",
      render: (row) => (
        <StackedCell
          primary={row?.shipment_type ?? "-"}
          secondary={row?.service_type ?? "-"}
        />
      ),
      width: "150px",
      disabled: (row) => isCancelled(row?.shipment_status),
    },
    {
      id: 4,
      label: "Status",
      render: (row) => <StatusIcons status={row?.shipment_status} />,
      width: "200px",
      disabled: (row) => isCancelled(row?.shipment_status),
    },
    {
      id: 22,
      label: "Total",
      render: (row) => {
        const charges = row?.shipment_charges;
        const previousTotal =
          charges?.length > 1 ? charges[charges.length - 2]?.total : null;
        return (
          <div>
            <div className="font-semibold tabular-nums text-ui-text">
              {formatMoney(row.Total)}{" "}
              <sup>{charges?.length > 1 ? `*${charges.length}` : ""}</sup>
            </div>

            <div className="shipments__total_prevamount tabular-nums">
              {previousTotal != null ? formatMoney(previousTotal) : ""}
            </div>
          </div>
        );
      },
      width: "200px",
      disabled: (row) => isCancelled(row?.shipment_status),
    },
    {
      id: 5,
      label: "Reference ID",
      render: (row) => <>{row?.referance_code ?? "-"}</>,
      width: "200px",
      disabled: (row) => isCancelled(row?.shipment_status),
    },
    {
      id: 6,
      label: "Tracking",
      render: (row) => (
        <StackedCell
          primary={
            <>
              <span className="text-ui-text-subtle font-normal">Bolt </span>
              {row?.tracking_id ? <HyperLink code={row.tracking_id} /> : "-"}
            </>
          }
          secondary={
            <>
              Carrier{" "}
              {row?.shipment_tracking_id ? (
                <HyperLink code={row.shipment_tracking_id} />
              ) : (
                "-"
              )}
            </>
          }
        />
      ),
      width: "250px",
      disabled: (row) => isCancelled(row?.shipment_status),
    },
    {
      id: 11,
      label: "Weight",
      render: (row) => (
        <>
          {row?.total_weight ?? "-"}
          {row?.unit === "Imperial" ? " lb" : " kg"}
        </>
      ),
      width: "200px",
      disabled: (row) => isCancelled(row?.shipment_status),
    },
    {
      id: 12,
      label: "Packages",
      render: (row) => <ShipmentPackagesPreview row={row} />,
      width: "200px",
      disabled: (row) => isCancelled(row?.shipment_status),
    },
    {
      id: 9,
      label: "Pickup",
      group: {
        label: "Pickup",
        children: [8, 13, 14, 15],
        defaultCollapsed: true,
      },
      render: (row) => (
        <>
          {" "}
          {row.PickupDate &&
            `${row.PickupDate?.slice(0, 10)}  ${
              row.readyopentime ? row.readyopentime?.slice(0, 5) : ""
            }${row.readyopentime && row.readyclosetime ? "-" : ""}${
              row.readyclosetime ? row.readyclosetime?.slice(0, 5) : ""
            }`}
          {!row.PickupDate && (
            <div
              className="putable__arrangepickup_btn"
              onClick={() => setAssignPickupModal(row)}
            >
              Arrange Pickup <FaEdit size={10} style={{ marginLeft: "5px" }} />
            </div>
          )}
        </>
      ),
      width: "250px",
      disabled: (row) => isCancelled(row?.shipment_status),
    },
    {
      id: 8,
      label: "Pickup ID",
      render: (row) => <>{row?.PickupID ?? "-"}</>,
      width: "200px",
      disabled: (row) => isCancelled(row?.shipment_status),
    },
    {
      id: 13,
      label: "Pickup City",
      render: (row) => <>{row?.fcity ?? "-"}</>,
      width: "200px",
      disabled: (row) => isCancelled(row?.shipment_status),
    },
    {
      id: 14,
      label: "Pickup Address",
      render: (row) => (
        <>
          <div className="content__wrapping_boltTable">
            {row?.faddress ?? "-"}
          </div>
        </>
      ),
      width: "300px",
      disabled: (row) => isCancelled(row?.shipment_status),
    },
    {
      id: 15,
      label: "Pickup Notes",
      render: (row) => <>{row?.finstructions ?? "-"}</>,
      width: "250px",
      disabled: (row) => isCancelled(row?.shipment_status),
    },
    {
      id: 10,
      label: "Customer Name",
      group: {
        label: "Delivery",
        children: [16, 17, 20],
        defaultCollapsed: true,
      },
      render: (row) => <>{row?.tattension ?? "-"}</>,
      width: "200px",
      disabled: (row) => isCancelled(row?.shipment_status),
    },
    {
      id: 16,
      label: "Delivery City",
      render: (row) => <>{row?.tcity ?? "-"}</>,
      width: "200px",
      disabled: (row) => isCancelled(row?.shipment_status),
    },
    {
      id: 17,
      label: "Delivery Address",
      render: (row) => (
        <>
          <div className="content__wrapping_boltTable">
            {row?.taddress ?? "-"}
          </div>
        </>
      ),
      width: "300px",
      disabled: (row) => isCancelled(row?.shipment_status),
    },
    {
      id: 20,
      label: "Delivery",
      render: (row) => (
        <StackedCell
          primary={`Req ${row?.delivery_date?.slice(0, 10) ?? "-"}`}
          secondary={`Est ${row?.estimated_delivery_date?.slice(0, 10) ?? "-"}`}
        />
      ),
      width: "150px",
      disabled: (row) => isCancelled(row?.shipment_status),
    },
    {
      id: 18,
      label: "Payment Status",
      group: { label: "Billing", children: [19], defaultCollapsed: true },
      render: (row) => <StatusIcons status={row?.payment_status ?? "Paid"} />,
      width: "200px",
      disabled: (row) => isCancelled(row?.shipment_status),
    },
    {
      id: 19,
      label: "Internal Status",
      render: (row) => <StatusIcons status={row?.user_invoice_status} />,
      width: "200px",
      disabled: (row) => isCancelled(row?.shipment_status),
    },
    {
      id: 24,
      label: "Created",
      render: (row) => {
        const name =
          row?.created_by?.username?.trim() || row?.user?.username?.trim();
        const createdAt = convertTime(row?.created_at);
        return (
          <StackedCell
            primary={name ? `By ${name}` : "-"}
            secondary={createdAt ? `At ${createdAt}` : "-"}
          />
        );
      },
      width: "200px",
      disabled: (row) => isCancelled(row?.shipment_status),
    },
    {
      id: 26,
      label: "Actions",
      render: (row) => (
        <ActionDropDown
          row={row}
          handleTicketOpen={handleTicketOpen}
          setInvoiceModal={setInvoiceModal}
          printDeclaration={printDeclaration}
          labelDownloading={labelDownloading}
          CircularLoader={CircularLoader}
          printLabel={printLabel}
          handleReShip={handleReShip}
          setConfirmCancel={setConfirmCancel}
        />
      ),
      width: "350px",
      fixed: "right",
      disabled: (row) => isCancelled(row?.shipment_status),
    },
  ];
  const getAllShipments = async (page, perPage, filter) => {
    const response = await fetchShipments(tab, page, perPage, filter);
    if (!response.error) {
      setShipments(response?.data?.result?.shipments);
      dispatch(
        updateUser({
          unReadShipments: response?.data?.result?.unReadShipmentCount,
        }),
      );
    } else {
      setSnack((snack) => {
        return {
          ...snack,
          open: true,
          text: "Something went wrong",
          severity: "error",
        };
      });
    }
  };

  return (
    <div
      className="dispatcher__screen"
      style={{ maxWidth: "100%", padding: "0px 5px" }}
    >
      <Confirm
        open={confirmCancel}
        setOpen={setConfirmCancel}
        handleConfirm={() => handleCancelShipment(confirmCancel)}
        text="Do you want to cancel this shipment?"
        loader={cancelingShipment}
        cancelLabel="Keep shipment"
        confirmLabel="Cancel shipment"
      />
      <InvoiceModal
        open={!!invoiceModal}
        data={invoiceModal}
        setData={setInvoiceModal}
        setShipments={setShipments}
        setOpen={setInvoiceModal}
        setSnack={setSnack}
      />
      <TicketCreateModal
        open={!!ticketCreateModal}
        setOpen={setTicketCreateModal}
        previousData={ticketCreateModal}
        setSnack={setSnack}
      />
      <AssignPickup
        open={assignPickupModal}
        setOpen={setAssignPickupModal}
        setSnack={setSnack}
        setShipments={setShipments}
      />
      <TabsComponent items={tabPermissions} tab={tab} setTab={setTab} />
      <div className="custom__table_size1 actionbtn__needtobe_fixwidth">
        <ShipmentsTable
          tableTitle="Shipments"
          tableId="shipments12TableforShipper"
          message={"No Shipments Available To Display!"}
          searchPlaceHolder={"Search Shipments"}
          getAllData={getAllShipments}
          data={shipments}
          columns={columns}
          refresh={tab}
          alert="✨ New feature: Upload required documents directly for UPS international shipments."
        />
      </div>
    </div>
  );
};

export default Shipments;
